import React from "react";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

const ConsultAdmissionCounselor = () => {
  return (
    <div style={{ padding: 20 }}>
      <Typography
        style={{ color: "#1d5f98", fontWeight: 600, fontSize: 20 }}
        variant="h5"
      >
        Connect with our Counselors
      </Typography>
      <Divider
        style={{
          backgroundColor: "rgb(58, 127, 187)",
          opacity: "0.3",
        }}
      />
      <div
        style={{
          paddingBottom: 10,
          paddingTop: 10,
          width: "90%",
          marginLeft: "4%",
        }}
      >
        <div>
          If you need any guidance regarding your academic career or finding it
          difficult to choose the right programme, please do not hesitate to
          talk to our counselors. Send us your name and query/concern at the
          following WhatsApp numbers and our team can arrange voice/video call
          with our certified counselors:
        </div>
        <ul>
          <li>
            0331 4141944 (For School of Economics and Management: IFP, BBA, BSc
            & A Levels)
          </li>
          <li>0331 4382299 (For School of Law: LLB)</li>
        </ul>
      </div>
    </div>
  );
};

export default ConsultAdmissionCounselor;
